import React, { useEffect, useState } from 'react';
import * as msTeams from "@microsoft/teams-js";
import { Loader } from '@progress/kendo-react-indicators';
import CiQPilot from './CiQPilot';

import { TeamsAuthProvider } from '../../contexts/TeamsAuthProvider';

const MsTeamsApp: React.FC = () => {
    const [isInTeams, setIsInTeams] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [teamsToken, setTeamsToken] = useState<string>("");
    const [tokenReceived, setTokenReceived] = useState<boolean>(false);
    
  useEffect(() => {
        if (isInTeams) {
            import("./MsTeamsApp.cssLoader");
        }
        }, [isInTeams]);

    useEffect(() => {
        const handleMessage = ({ data }: MessageEvent) => {
            if (data && typeof data === 'string') {
                setTeamsToken(data);
                setTokenReceived(true);
                console.log("Teams token received:", data);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    // useEffect(() => {
    //     const initialize = async () => {
    //         setLoading(true);
    //         const _isInTeams = true;//await checkInTeams();
    //         setIsInTeams(_isInTeams);
    //         setLoading(false);
    //     };
    
    //     initialize();
    // }, []); 

    // const checkInTeams = async () => {
    //     if (!msTeams || !msTeams.app){
    //         return false;
    //     }
    //     try {
    //         await msTeams.app.initialize();
    //         let context = await msTeams.app.getContext();
    //         if (!context) {
    //             return false;
    //         }
    //         return !!context.app.host.clientType;
    //     } catch (error) {
    //         console.error("Error checking Teams context:", error);
    //         return false;
    //     }
    // };

    return (
        <div className="mt-50 float-left w-100 text-center h-100">
            {loading ? (
                <Loader type={"infinite-spinner"} />
            ) : (
                <div className='h-100'>
                    {isInTeams ? (
                        <div className='h-100'>
                            {tokenReceived ? (
                                <TeamsAuthProvider>
                                    <CiQPilot token={teamsToken} inTeams={true} />
                                </TeamsAuthProvider>
                            ) : (
                                <div className='h-100 d-flex align-items-center justify-content-center flex-column'>
                                    <Loader type={"infinite-spinner"} />
                                    <p>Waiting for authentication token...</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className='h-100 d-flex align-items-center justify-content-center flex-column'>
                            <h1>404 Not Found</h1>
                            <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MsTeamsApp;